<template>
  <div class="churn-button" v-on:click="openChurnFlow">
    <span class="button-title">סגירת חשבון ומחיקת פרטים</span>
    <span class="button-icon fa fa-chevron-left"></span>
  </div>
</template>

<script>
import ModalBus from '../../../../../../event-bus/modal-bus';
import ChurnDescriptionPopup from '../../../churn/ChurnDescriptionPopup.vue';
import Segment from '../../../../../../Segment';

export default {
  name: 'ChurnButton',
  methods: {
    openChurnFlow() {
      Segment.trackUserInteraction('ChurnButtonClicked');
      ModalBus.$emit('open', {
        component: ChurnDescriptionPopup,
      });
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "~base-ui/src/scss/riseup-colors";

  .churn-button {
    height: 64px;
    width: 100%;
    padding: 0 23px;
    border-radius: 5px;
    box-shadow: 0 0 6px 0 $riseup_gray_1;
    display: inline-flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;

    .button-title {
      font-size: 16px;
      font-weight: bold;
      color: $riseup_coral;
    }

    .button-icon {
      color: $riseup_coral;
    }
  }
</style>
